<template>
  <div class="contact">
    <div v-if="sent" class="contact-us w100p df fdc sent">
      <h2>We appreciate your feedback.</h2>      
      <h4>Thank you!</h4>
      <a class="button-1" @click="goTo('/')">Continue</a>
    </div>
    <div v-else class="contact-us w100p df fdc">
      <h2>Questions? Suggestions?</h2>      
      <h4>Drop us a line!</h4>
      <p>Email</p>
      <input type="text" placeholder="Your Email" v-model="email">
      <p>Message</p>
      <textarea class="message" placeholder="Message" v-model="message"></textarea>
      <a v-if="sending" class="button-1">Sending...</a>
      <a v-else class="button-1" @click="submitMessage()">Send</a>
    </div>
  </div>
</template>

<script>
import router from '@/router'
export default {
  // import Login from '../components/Login'

  name: 'Contact',
  data () {
    return {
      email: '',
      message: '',
      sending: false,
      sent: false
    }
  },
  props: [],
  components: {

  },
  methods: {
    goTo (path) {
      router.push(path)
    },
    submitMessage () {
      if (this.email && this.message) {
        this.sending = true
        this.$store.dispatch('AUTH.submitMessage', {
          email: this.email,
          message: this.message,
        }).then((res) => {
          console.log('res', res)
          if (res.message == 'ok') {
            this.sent = true
            this.sending = false
          } else {
            this.sending = false
          }
          // this.error = ''
        }).catch((err) => {
          console.log('err', err)
            this.sent = false
            this.sending = false
        })
      }
    },
  },
  computed: {

  },
  created () {
    // console.log('** Login Component Loaded')
  }
}
</script>

<style scoped lang="scss">
h2 {
  color: #000000;
  font-family: Inter;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
}
h4 {
  color: #000000;
  font-family: Inter;
  font-size: 48px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 59px;
}
.contact {
  padding-top: 100px;
}
.contact-us {
  padding: 60px 90px;
  background-color: #fff;
  border-radius: 5px;
}
textarea {
  height: 120px;
}
input, textarea {
  max-width: 390px;
  border-radius: 2px;
  border: none;
  background-color: #F3F3F5;
  color: #5C5C5C;
  font-family: Inter;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 15px;
  padding: 14px 18px;
  margin-bottom: 27px;
}
p {
  color: #49494C;
  font-family: Inter;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 17px;
  margin-bottom: 13px;
}
h2 {
  margin-bottom: 4px;
}
h4 {
  margin-bottom: 24px;
}

@media (max-width: 900px) {
  .contact-us {
/*    padding-left: 30px;
    padding-right: 30px;*/
  }
}

@media (max-width: 600px) {
  .contact-us {
    padding-left: 30px;
    padding-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue